// extracted by mini-css-extract-plugin
export default {"avatar":"CircleAvatar_avatar__CXMs5"};